import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { updateMessagingRecordedTab } from '../../../../../../../store/mockServices/mockServiceDetail/mockServiceDetailActions';
import { RecordingSettingButtons } from './RecordingSettingsButtons';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../store/rootReducer';
import HttpRecordings from './HttpRecordings';
import { HttpRecorderConfig, MockService } from '../../../../../../../types/rest/mockServiceTypes';
import { MockParameterState } from '../../../MockParameters';
import { runnerContentTabStyles } from '../../Runners/HttpRunnerTabs';
import HttpRecordingSettings from './HttpRecordingSettings';

interface HttpRecordingConfigProps {
  disabled: boolean;
  onUpdate: (params: MockParameterState) => void;
  mockService: MockService;
}

const HttpRecordingConfig = ({ disabled, onUpdate, mockService }: HttpRecordingConfigProps) => {
  const {
    httpRecorderConfigDto = {
      maxRequestSize: 1000,
      maxRequestsPerSecond: 100,
      liveSystemUrl: '',
      assets: [],
      configKeyAssets: [],
    },
  } = mockService;

  const updateConfigHandler = (fieldName: keyof HttpRecorderConfig | 'certificate', value: any) => {
    // Ensure deep copy and provide fallback if config is empty
    const httpRecorderConfig: HttpRecorderConfig = {
      ...httpRecorderConfigDto,
    } || {
      maxRequestSize: 1000,
      maxRequestsPerSecond: 100,
      liveSystemUrl: '',
      assets: [],
      configKeyAssets: [],
    };

    switch (fieldName) {
      case 'certificate':
        httpRecorderConfig.assets = value.assets ?? [];
        httpRecorderConfig.configKeyAssets = value.configKeyAssets ?? [];
        break;
      case 'maxRequestSize':
      case 'maxRequestsPerSecond':
        httpRecorderConfig[fieldName] = Number.isNaN(parseInt(value)) ? 0 : parseInt(value);
        break;
      default:
        httpRecorderConfig[fieldName] = value;
    }
    const ms = { ...mockService, httpRecorderConfigDto: httpRecorderConfig };
    onUpdate(ms);
  };

  const activeTab = useSelector((state: ApplicationState) => state.mockServiceDetails.recordingConfigTab);
  const dispatch = useDispatch();

  return (
    <div className={runnerContentTabStyles}>
      <Row>
        <Col>
          <RecordingSettingButtons
            activeTab={activeTab}
            onTabChange={tab => {
              dispatch(updateMessagingRecordedTab(tab));
            }}
            buttonText={'Recorded Transactions'}
          />
        </Col>
      </Row>
      {activeTab === 'settings' && (
        <HttpRecordingSettings
          httpRecorderConfigDto={httpRecorderConfigDto}
          disabled={disabled}
          updateConfigHandler={(key: any, value) => {
            updateConfigHandler(key, value);
          }}
          isHttpRecording={true}
        />
      )}

      {activeTab === 'recordedMessages' && <HttpRecordings mockService={mockService} disabled={disabled} />}
    </div>
  );
};

export default HttpRecordingConfig;
